import NewRma from './ui/newRma';

export default NewRma;
